import React from 'react';
import cx from 'classnames';

type Props = {
  hp: number;
  max: number;
};

export default function EnhancedMarkdownHealthBar({
  hp,
  max,
}: Props): JSX.Element {
  const percent = hp / max;

  const hpFormatted = formattedNumber(Number(hp));
  return (
    <div
      className={cx([
        'enhanced-markdown-health-bar',
        percent < 0.001 && 'enhanced-markdown-health-bar--empty',
      ])}
      style={
        {
          '--health-percent': percent,
        } as React.CSSProperties
      }
    >
      <div className={'enhanced-markdown-health-bar__health'}></div>
      <span className={'enhanced-markdown-health-bar__label'}>
        {hpFormatted} - {(percent * 100).toFixed(1)}%
      </span>
    </div>
  );
}

// stolen from report.js. Intl.NumberFormat just looks...off. i18n?
function formattedNumber(num: number) {
  if (num > 1000000000) {
    num /= 1000000000;
    return num.toFixed(2) + 'b';
  }

  if (num > 100000000) {
    num /= 1000000;
    return num.toFixed(0) + 'm';
  }

  if (num > 10000000) {
    num /= 1000000;
    return num.toFixed(1) + 'm';
  }

  if (num > 1000000) {
    num /= 1000000;
    return num.toFixed(2) + 'm';
  }

  if (num > 1000) {
    num /= 1000;
    return num.toFixed(0) + 'k';
  }

  return num.toFixed(1);
}
